/**
 * TRUS-762 — staff v2 styling for the forms chrome (library, hub, editor
 * header/footer). The design-system <Button>/<Card> carry legacy palette
 * classes (blue primary, gray secondary, white card); these class strings sit
 * on top of them so every forms surface reads as one: one surface colour, the
 * v2 border, ink text, teal accent for the primary action.
 *
 * `!` (important) because the component's own bg/text utilities are emitted in
 * the same Tailwind layer, and which one wins would otherwise depend on CSS
 * order rather than intent.
 *
 * NOT for the form BODY: fields there are painted by the org's brand form theme
 * (formTheme / themeToCssVars) and must keep doing so.
 */

/** Primary action: teal accent. Use with <Button variant="primary">. */
export const FORMS_PRIMARY_BTN =
  '!bg-v2accent hover:!bg-v2accent/90 !text-white focus:!ring-v2accent !shadow-none hover:!shadow-none';

/** Secondary action: quiet bordered button on the surface colour. Use with <Button variant="secondary">. */
export const FORMS_SECONDARY_BTN =
  '!bg-surface hover:!bg-paper-2 !text-ink !border !border-v2border focus:!ring-v2accent';

/** Icon-only / tertiary action. Use with <Button variant="ghost">. */
export const FORMS_GHOST_BTN = '!text-ink-500 hover:!text-ink hover:!bg-paper-2 focus:!ring-v2accent';

/** Panels and cards: one surface colour, v2 border, no drop shadow. */
export const FORMS_SURFACE = '!bg-surface !border-v2border !text-ink !shadow-none';

/** Muted copy. */
export const FORMS_MUTED = 'text-ink-500';

/** Table header row. */
export const FORMS_TABLE_HEAD = 'text-[11px] uppercase tracking-wide text-ink-500 font-medium';

/** Tabs bar and its active trigger. */
export const FORMS_TABS_LIST = '!bg-paper-2 border border-v2border w-fit';
export const FORMS_TAB_TRIGGER =
  'gap-2 text-ink-500 data-[state=active]:!bg-surface data-[state=active]:!text-ink';

/** Accent count pill inside a tab or section header. */
export const FORMS_COUNT_PILL =
  'ml-1 inline-flex items-center justify-center min-w-[1.25rem] px-1.5 rounded-full text-[11px] font-semibold bg-v2accent-soft text-v2accent-ink';
